import axios from "axios";
import apiUrlOne from "../Config";


export const getAllUsers = async (search = "") => {
    try {
        const url = `${apiUrlOne}/users/getall-users`;
        console.log("Final Request URL:", url, "Search param:", search);

        const response = await axios.get(url, {
            params: { search }
        });

        return response.data;
    } catch (error) {
        console.error("getAllUsers Error:", error.response?.data || error.message);
        throw error;
    }
};


export const getUserDetails = async (id) => {
    try {
        const url = `${apiUrlOne}/users/getuserdetails/${id}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("getUserDetails Error:", error.response?.data || error.message);
        throw error;
    }
};
